import * as React from "react";
import { Input, Table } from "reactstrap";
import { settings } from "../../constants";
import IPbiDashboard from "../../models/IPbiDashboard";

export interface IDashboardDetailsTableProps {
  dashboard: IPbiDashboard;
}

const DashboardDetailsTable: React.SFC<IDashboardDetailsTableProps> = (
  props: IDashboardDetailsTableProps
) => {
  const { dashboard } = props;
  const {
    displayName,
    name,
    groupId,
    reportId,
    dashboardViewerVersion,
    isEnabled
  } = dashboard;
  const { allowDisableDashboards } = settings;
  return (
    <Table striped={true}>
      {/* <thead>
        <tr>
          <th>Field</th>
          <th>Value</th>
        </tr>
      </thead> */}
      <tbody>
        <tr>
          <th scope="row">Display Name</th>
          <td> {displayName}</td>
        </tr>
        <tr>
          <th scope="row">Name</th>
          <td> {name}</td>
        </tr>
        <tr>
          <th scope="row">Group ID</th>
          <td> {groupId}</td>
        </tr>
        <tr>
          <th scope="row">Report Id</th>
          <td> {reportId}</td>
        </tr>
        <tr>
          <th scope="row">Dashboard Viewer Version Number</th>
          <td> {dashboardViewerVersion}</td>
        </tr>
        {allowDisableDashboards && (
          <tr>
            <th scope="row">Enabled</th>
            <td>
              <Input type="checkbox" checked={isEnabled} readOnly={true} />
              {isEnabled}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default DashboardDetailsTable;
